import React, { useState } from 'react'

type LocationInfo = {
  name: string;
  address: string;
  addressLink: string;
  sales: {
    title: string;
    phone: string;
    email: string;
  }[];
  service: {
    title: string;
    phone: string;
    email: string;
  };
  suggestions: {
    title: string;
    email: string;
  };
}

const locations: Record<string, LocationInfo> = {
  ploiesti: {
    name: 'Ploiești',
    address: 'Str. Strandului nr 70, Prahova',
    addressLink: 'https://www.google.ro/maps/place/Magazia+Lu\'+Costica/@44.9588068,26.053362,17z/data=!3m1!4b1!4m5!3m4!1s0x40b24a6ba693e897:0x92c9c2e58b625d39!8m2!3d44.9588068!4d26.0555507',
    sales: [
      {
        title: 'Vanzari tractoare si utilaje agricole',
        phone: '0371.710.074',
        email: 'comenzi@magazialucostica.ro'
      },
      {
        title: 'Vanzari online(motounelte,motoutilaje si unelte)',
        phone: '0371.710.071',
        email: 'comenzi@magazialucostica.ro'
      },
      {
        title: 'Vanzari piese de schimb(tractoare si utilaje agricole)',
        phone: '0371.710.072',
        email: 'piese@magazialucostica.ro'
      }
    ],
    service: {
      title: 'Service',
      phone: '0371.710.073',
      email: 'service@magazialucostica.ro'
    },
    suggestions: {
      title: 'Sugestii si reclamatii',
      email: 'costica@magazialucostica.ro'
    }
  },
  oradea: {
    name: 'Oradea',
    address: 'str. Suișului, nr. 6A, Oradea, Bihor',
    addressLink: 'https://www.google.com/maps/place/Magazia+Lu\'+Costica+Oradea/@47.1080229,21.8923618,17z/data=!3m1!4b1!4m5!3m4!1s0x4746375d0eed67e9:0x2716d3b42788e711!8m2!3d47.1080193!4d21.8945505',
    sales: [
      {
        title: 'Vanzari tractoare si utilaje agricole',
        phone: '0371.710.074',
        email: 'oradea@magazialucostica.ro'
      },
      {
        title: 'Vanzari online(motounelte,motoutilaje si unelte)',
        phone: '0371.710.071',
        email: 'comenzi@magazialucostica.ro'
      },
      {
        title: 'Vanzari piese de schimb(tractoare si utilaje agricole)',
        phone: '0371.710.072',
        email: 'piese@magazialucostica.ro'
      }
    ],
    service: {
      title: 'Service',
      phone: '0371.710.073',
      email: 'service@magazialucostica.ro'
    },
    suggestions: {
      title: 'Sugestii si reclamatii',
      email: 'costica@magazialucostica.ro'
    }
  }
}

export const ContactMap = () => {
  const [selectedLocation, setSelectedLocation] = useState<string>('ploiesti')
  const basePath = '/static/frontend/Eadesignro/desktop/ro_RO/images/'

  return (
    <div className="ctc-map xl:ml-[30px] relative flex gap-[30px] items-start">
      <div className="hidden xl:flex xl:flex-col ctc-left1 flex-1 min-w-[300px] pr-[15px]">
        <h3 className="text-contact-gray font-montserrat text-base md:text-base md:text-[18px] font-bold pl-[17px] mt-0 mb-[17px]">
          Alege punctul de vanzare din regiunea ta
        </h3>
        <div 
          className="ctc-harta relative w-full max-w-[728px] h-[500px] bg-no-repeat bg-center bg-contain"
          style={{ backgroundImage: `url(${basePath}romania_map_new.svg)` }}
        >
          
          {/* Punct Ploiești */}
          <div 
            className={`ctc-ploiesti sediu absolute top-[60%] right-[32%] cursor-pointer group`}
            onClick={() => setSelectedLocation('ploiesti')}
          >
            <svg 
              className="w-[28px] h-[28px] group-hover:text-main-orange text-tooltip-bg transition-colors duration-200"
              viewBox="0 0 28 28"
              fill="none"
            >
              <circle cx="14" cy="14" r="4" fill="currentColor" />
              <circle cx="14" cy="14" r="8" stroke="currentColor" strokeWidth="2" fill="none" />
              <circle cx="14" cy="14" r="12" stroke="currentColor" strokeWidth="1.5" fill="none" />
            </svg>
            <span className="tooltiptext absolute opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity duration-200 text-white font-nunito text-[14px] leading-[1.5] bg-tooltip-bg rounded-[30px] rounded-bl-none p-[15px] top-[-30px] left-[30px] whitespace-nowrap text-center">
              Ploiești
            </span>
          </div>

          {/* Punct Oradea */}
          <div 
            className={`ctc-oradea sediu absolute top-[25%] right-[78%] cursor-pointer group`}
            onClick={() => setSelectedLocation('oradea')}
          >
            <svg 
              className="w-[28px] h-[28px] group-hover:text-main-orange text-tooltip-bg transition-colors duration-200"
              viewBox="0 0 28 28"
              fill="none"
            >
              <circle cx="14" cy="14" r="4" fill="currentColor" />
              <circle cx="14" cy="14" r="8" stroke="currentColor" strokeWidth="2" fill="none" />
              <circle cx="14" cy="14" r="12" stroke="currentColor" strokeWidth="1.5" fill="none" />
            </svg>
            <span className="tooltiptext absolute opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity duration-200 text-white font-nunito text-[14px] leading-[1.5] bg-tooltip-bg rounded-[30px] rounded-bl-none p-[15px] top-[-30px] left-[30px] whitespace-nowrap text-center">
              Oradea
            </span>
          </div>
        </div>
      </div>

      <div className="ctc-right1 md:min-w-[300px] flex flex-col md:gap-5 p-3 md:flex-row items-start h-full">
        <div className={`flex flex-col ${selectedLocation === 'ploiesti' ? 'xl:flex' : 'xl:hidden'}`}>
          <div className="store mb-[36px]">
            <span className="nume-sediu text-main-orange font-montserrat text-xl md:text-2xl italic font-bold">
              {locations.ploiesti.name}
            </span>
            <p>
              <a href={locations.ploiesti.addressLink} target="_blank" className="text-price-color hover:underline">
                {locations.ploiesti.address}
              </a>
            </p>
          </div>
          
          {locations.ploiesti.sales.map((sale, index) => (
            <div key={index} className="vanzari ">
              <h5 className="text-price-color font-montserrat text-base md:text-[18px] font-bold mt-[26px] mb-[15px]">
                {sale.title}
              </h5>
              <div>
                <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                  Mobil: 
                </span>
                <span className="telefon">
                  <a href={`tel:${sale.phone}`} className="text-price-color font-montserrat text-base md:text-[18px]">
                  {' '}{sale.phone}
                  </a>
                </span>
              </div>
              <div>
                <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                  Email: 
                </span>
                <span className="email">
                  <a href={`mailto:${sale.email}`} className="text-price-color hover:underline">
                  {' '}{sale.email}
                  </a>
                </span>
              </div>
              {index === 2 && (
                <span className="nota text-contact-gray font-nunito text-base md:text-[18px] leading-[29px]">
                  Pentru a fi cat mai operativi si pentru a identifica mai usor piesele dorite de dumneavoastra
                  <span className="bold text-price-color"> va rugam sa completati </span>
                  <span className="underline text-price-color">formularul de contact</span> selectand
                  subiectul <span className="bold text-price-color">Piese de schimb.</span>
                </span>
              )}
            </div>
          ))}

          <div className="vanzari ">
            <h5 className="text-price-color font-montserrat text-base md:text-[18px] font-bold mt-[26px] mb-[15px]">
              {locations.ploiesti.service.title}
            </h5>
            <div>
              <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                Mobil: 
              </span>
              <span className="telefon">
                <a href={`tel:${locations.ploiesti.service.phone}`} className="text-price-color font-montserrat text-base md:text-[18px]">
                {' '}{locations.ploiesti.service.phone}
                </a>
              </span>
            </div>
            <div>
              <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                Email:  
              </span>
              <span className="email">
                <a href={`mailto:${locations.ploiesti.service.email}`} className="text-price-color hover:underline">
                {' '}{locations.ploiesti.service.email}
                </a>
              </span>
            </div>
          </div>

          <div className="vanzari ">
            <h5 className="text-price-color font-montserrat text-base md:text-[18px] font-bold mt-[26px] mb-[15px]">
              {locations.ploiesti.suggestions.title}
            </h5>
            <div>
              <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                Email: 
              </span>
              <span className="email">
                <a href={`mailto:${locations.ploiesti.suggestions.email}`} className="text-price-color hover:underline">
                {' '}{locations.ploiesti.suggestions.email}
                </a>
              </span>
            </div>
          </div>
        </div>

        <div className={`flex flex-col ${selectedLocation === 'oradea' ? 'xl:flex' : 'xl:hidden'}`}>
          <div className="store mb-[36px]">
            <span className="nume-sediu text-main-orange font-montserrat text-xl md:text-2xl italic font-bold">
              {locations.oradea.name}
            </span>
            <p>
              <a href={locations.oradea.addressLink} target="_blank" className="text-price-color hover:underline">
                {locations.oradea.address}
              </a>
            </p>
          </div>
          
          {locations.oradea.sales.map((sale, index) => (
            <div key={index} className="vanzari ">
              <h5 className="text-price-color font-montserrat text-base md:text-[18px] font-bold mt-[26px] mb-[15px]">
                {sale.title}
              </h5>
              <div>
                <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                  Mobil: 
                </span>
                <span className="telefon">
                  <a href={`tel:${sale.phone}`} className="text-price-color font-montserrat text-base md:text-[18px]">
                  {' '}{sale.phone}
                  </a>
                </span>
              </div>
              <div>
                <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                  Email: 
                </span>
                <span className="email">
                  <a href={`mailto:${sale.email}`} className="text-price-color hover:underline">
                  {' '}{sale.email}
                  </a>
                </span>
              </div>
              {index === 2 && (
                <span className="nota text-contact-gray font-nunito text-base md:text-[18px] leading-[29px]">
                  Pentru a fi cat mai operativi si pentru a identifica mai usor piesele dorite de dumneavoastra
                  <span className="bold text-price-color"> va rugam sa completati </span>
                  <span className="underline text-price-color">formularul de contact</span> selectand
                  subiectul <span className="bold text-price-color">Piese de schimb.</span>
                </span>
              )}
            </div>
          ))}

          <div className="vanzari ">
            <h5 className="text-price-color font-montserrat text-base md:text-[18px] font-bold mt-[26px] mb-[15px]">
              {locations.oradea.service.title}
            </h5>
            <div>
              <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                Mobil: 
              </span>
              <span className="telefon">
                <a href={`tel:${locations.oradea.service.phone}`} className="text-price-color font-montserrat text-base md:text-[18px]">
                  {' '}{locations.oradea.service.phone}
                </a>
              </span>
            </div>
            <div>
              <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                Email: 
              </span>
              <span className="email">
                <a href={`mailto:${locations.oradea.service.email}`} className="text-price-color hover:underline">
                {' '}{locations.oradea.service.email}
                </a>
              </span>
            </div>
          </div>

          <div className="vanzari ">
            <h5 className="text-price-color font-montserrat text-base md:text-[18px] font-bold mt-[26px] mb-[15px]">
              {locations.oradea.suggestions.title}
            </h5>
            <div>
              <span className="mobil text-price-color font-montserrat text-base md:text-[18px] leading-0 font-normal">
                Email: 
              </span>
              <span className="email">
                <a href={`mailto:${locations.oradea.suggestions.email}`} className="text-price-color hover:underline">
                {' '}{locations.oradea.suggestions.email}
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}